
import { useState, useEffect, useContext } from 'react';
import './home.css'
import NavComponent from '../../components/navComponent/NavComponent'
import Footer from '../../components/footer/Footer'
import { boxes, questions, servicesBig, servicesTiny } from '../../data'
import Slider from '../../components/slider/Slider';
import CarouselSection2 from '../../components/carouselSection2/CarouselSection2';
import { LangContext } from '../../context/langContext/LangContext';
import { langData } from '../../langData';
import { CLIENT_URL, CURRENT_URL } from '../../config/runtimeConfig';

function Home() {
    const [questionIndex, setQuestionIndex] = useState("");
    const [matches, setMatches] = useState(window.matchMedia("(min-width: 736px)").matches)
    const { lang } = useContext(LangContext)

    const handleQuestion = (index) => {
        if (questionIndex === index) {
            setQuestionIndex("")
        } else {
            setQuestionIndex(index)
        }
    }

    useEffect(() => {
        window.matchMedia("(min-width: 736px)").addEventListener('change', e => setMatches(e.matches));
    }, []);

    return (
        <>
            <NavComponent />


            <div className="container">
                {/*  <!-- Sliders -->  */}
                <Slider />

                {/*  <!-- Section 1 -->  */}
                {/* <div className="section section-1" id="accueil">
                    <span className="sub-title">Pour les services de livraison locaux</span>
                    <span className="title">NW Express est une solution pour la gestion des opérations logistiques quotidiennes de transport et de livraison.</span>
                    <span className="bottom-title">
                        Gérez efficacement vos opérations de livraison avec un suivi en temps réel, une gestion
                        des commandes, des analyses et bien plus encore.
                    </span>
                    <div className="buttons">
                        <a href={`${CLIENT_URL}`} target="_blank">Suivre Votre Colis</a>
                        <a href={`${CLIENT_URL}`} target="_blank">Se Connecter</a>
                    </div>
                </div> */}


                {/*  "<!-- Section 2 -->"  */}
                <div className="section section-2">
                    <h1>{langData[lang]["titles"]["nos_partenaires"]}</h1>
                    <div className='box-section-2'>
                        {/* <img src={`${CURRENT_URL}/slides/diardzair.png`} alt="" />
                        <img src={`${CURRENT_URL}/slides/i3mal.png`} alt="" />
                        <img src={`${CURRENT_URL}/slides/jumia.jpg`} alt="" /> */}
                        <CarouselSection2 />
                    </div>
                </div>


                {/*  "<!-- Section 3 -->"  */}
                <div className="section section-3">
                    <h1>{langData[lang]["titles"]["nos_services"]}</h1>
                    <div style={{ "marginBottom": "5px" }}>
                        {
                            servicesTiny.map((item, index) => (
                                <div key={index} className="box tiny">
                                    <div className="box-title">
                                        <i className={item.icon}></i>
                                        <span>{item.title[lang]}</span>
                                    </div>
                                    <div className="box-content">
                                        <p>{item.content[lang]}</p>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    <div>
                        {
                            servicesBig.map((item, index) => (
                                <div key={index} className="box big">
                                    <div className="box-title">
                                        <i className={item.icon}></i>
                                        <span>{item.title[lang]}</span>
                                    </div>
                                    <div className="box-content">
                                        <p>{item.content[lang]}</p>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>


                {/*   "<!-- Section 4 -->"   */}
                <div className="section section-4" id='propos'>
                    <h1>{langData[lang]["titles"]["nos_offres"]}</h1>
                    {
                        boxes.map((item, index) => (
                            matches ? (  // if the window with > 736px
                                <div key={index} className="box">
                                    {
                                        (index % 2 == 1) && (
                                            <div className="box-img">
                                                <img src={`${CURRENT_URL}/${item.image}`} alt="" />
                                            </div>
                                        )
                                    }
                                    <div className="box-content">
                                        <div className="box-sub-title">
                                            <span>{item.sub_title[lang]}</span>
                                        </div>
                                        <div className="box-title">
                                            <span>{item.title[lang]}</span>
                                        </div>
                                        <div className="box-paragraph">
                                            <p>{item.content[lang]}</p>
                                        </div>
                                        {
                                            (item.link !== "") && (
                                                <a href={`${CLIENT_URL}`} target="_blank" className="box-link">
                                                    <span>{item.link[lang]}</span>
                                                    <i className='bx bx-right-arrow-alt' ></i>
                                                </a>
                                            )
                                        }
                                    </div>
                                    {
                                        (index % 2 == 0) && (
                                            <div className="box-img">
                                                <img src={`${CURRENT_URL}/${item.image}`} alt="" />
                                            </div>
                                        )
                                    }
                                </div>
                            ) : (  // if the window with < 736px

                                <div key={index} className="box">
                                    <div className="box-content">
                                        <div className="box-sub-title">
                                            <span>{item.sub_title[lang]}</span>
                                        </div>
                                        <div className="box-title">
                                            <span>{item.title[lang]}</span>
                                        </div>
                                        <div className="box-paragraph">
                                            <p>{item.content[lang]}</p>
                                        </div>
                                        {
                                            (item.link !== "") && (
                                                <a href={`${CLIENT_URL}`} target="_blank" className="box-link">
                                                    <span>{item.link[lang]}</span>
                                                    <i className='bx bx-right-arrow-alt' ></i>
                                                </a>
                                            )
                                        }
                                    </div>
                                    <div className="box-img">
                                        <img src={`${CURRENT_URL}/${item.image}`} alt="" />
                                    </div>
                                </div>
                            )
                        ))
                    }
                </div>

                {/*  "<!-- Section 5 -->"  */}
                <div className="section section-5" id="faq">
                    <h1>{langData[lang]["titles"]["questions_frequemment_posees"]}</h1>
                    <div className="wrapper">
                        {
                            questions.map((item, index) => (
                                <div key={index} className="parent-tab">
                                    <label onClick={() => handleQuestion(index)} className={questionIndex === index ? 'active' : ''}>
                                        <span>{item.title}</span>
                                        <div className="icon">
                                            <i className="fas fa-plus"></i>
                                        </div>
                                    </label>
                                    <div className="content">
                                        <p>{item.content}</p>
                                    </div>
                                </div>
                            ))
                        }

                        {/*   "<!-- Auther Question -->"   */}
                        <div className="other">
                            <span>{langData[lang]["others"]["autre_question"]}</span> <br />
                            <a href="#">
                               {langData[lang]["buttons"]["contacter_centre_appels"]}
                                <i className='bx bx-right-arrow-alt' ></i>
                            </a>
                        </div>
                    </div>
                </div>


            </div>



            <Footer />
        </>
    )
}

export default Home
